export default __webpack_public_path__ + "static/figure1-2e4e15a2aee3e385cb64c3571e542d62.webp";